module.exports = (RESTService, SalonService) ->
  'ngInject'
  (salonId) ->
    RESTService.service('schedule_breaks', SalonService.one(salonId))
